@if (isTrackerFooter) {
  <div
    class="spend-tracker"
    [class.footer-threshold-met]="isThresholdMet"
    role="region"
    [attr.aria-label]="
      'Spend tracker: ' +
      trackerContent.total.title +
      ' spent out of ' +
      trackerContent.max +
      ' maximum'
    "
  >
    <div
      class="spend-tracker__progress-bar-labels"
      role="group"
      aria-label="Spend tracker labels"
    >
      <div class="spend-tracker__progress-bar-labels__left">
        <span
          class="spend-tracker__progress-bar-labels__left__progress-value"
          role="text"
          [attr.aria-label]="
            'Current spend amount: ' + trackerContent.total.title
          "
          data-cy="skyclub-spend-tracker-footer-total-spend-amount"
        >
          {{ trackerContent.total.title }}
        </span>
        <span
          class="spend-tracker__progress-bar-labels__left__total-spend"
          role="text"
          data-cy="skyclub-spend-tracker-footer-total-spend-year-text"
        >
          {{ trackerContent.total.subtitle }}
        </span>
        <button
          auraTooltip
          [tooltipContent]="{
            position: 'bottom-right',
            trapFocus: true,
            hideCloseIcon: false,
            color: '#0b1f66',
            info: trackerContent.iconLink.information || ''
          }"
          class="spend-tracker__progress-bar-labels__left__tooltip-icon"
          role="button"
          [attr.aria-label]="'More information about spend tracker terms and conditions'"
          [attr.aria-describedby]="'spend-tracker-tooltip'"
          data-cy="skyclub-spend-tracker-footer-tooltip"
          (click)="searchEligibleClick.emit('tooltip')"
        >
          <img alt="Info Icon" role="img" />
        </button>
      </div>
      <div class="spend-tracker__progress-bar-labels__right">
        <span
          class="spend-tracker__progress-bar-labels__right__max-spend"
          role="text"
          [attr.aria-label]="'Maximum spend amount: ' + trackerContent.max"
          data-cy="skyclub-spend-tracker-footer-spend-goal-amount"
        >
          {{ trackerContent.max }}
        </span>
      </div>
    </div>
    <div
      class="spend-tracker__progress-bar"
      role="progressbar"
      [attr.aria-valuenow]="spendProgress"
      [attr.aria-valuemin]="0"
      [attr.aria-valuemax]="75000"
      [attr.aria-label]="
        'Spend progress: ' +
        spendProgress +
        ' dollars out of 75,000 dollars, ' +
        progressPercentage.toFixed(1) +
        ' percent complete'
      "
      data-cy="skyclub-spend-tracker-footer-spend-progress-bar"
    >
      <div
        class="spend-tracker__progress-bar--fill"
        [style.width.%]="progressPercentage"
        aria-hidden="true"
      ></div>
    </div>
    <div class="spend-tracker__remaining-spend-label">
      <span
        [innerHTML]="trackerContent.spendLink.label"
        [attr.aria-label]="'Learn more: ' + trackerContent.spendLink.label"
        data-cy="skyclub-spend-tracker-footer-additional-info-text"
      ></span>
    </div>
  </div>
} @else {
  <a
    [href]="tooltipContent.url"
    target="_blank"
    class="search-eligible-footer"
    role="link"
    [attr.aria-label]="'Navigate to: ' + tooltipContent.label"
    (click)="searchEligibleClick.emit('link')"
  >
    <div class="search-eligible-footer__left">
      @if (tooltipContent.image) {
        <img
          class="search-eligible-footer__icon"
          [src]="tooltipContent.image.src"
          [alt]="tooltipContent.image.alt"
          role="img"
        />
      }
      <span [innerHTML]="tooltipContent.label"></span>
    </div>
    <div
      class="search-eligible-footer__arrow"
      role="presentation"
      aria-hidden="true"
    ></div>
  </a>
}
